import React from 'react';
import { useParams } from 'react-router-dom';
import ChatComponent from '../components/ChatComponent';
import { useChat } from '../contexts/ChatContext';

const ChatPage = () => {
  const { id } = useParams();
  const { socket } = useChat();

  if (!socket) {
    return (
      <div className="h-[100dvh] bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-2 border-blue-500 border-t-transparent mx-auto"></div>
          <p className="mt-4 text-gray-600">Connecting to chat...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="h-[100dvh] bg-white">
      <ChatComponent initialConnectionId={id} />
    </div>
  );
};

export default ChatPage;